import axios from "axios";

const api = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || "http://localhost:8080/api").replace(/\/+$/, ""),
  withCredentials: false,
});

api.interceptors.request.use(
  (config) => {
    console.log("🔄 Haciendo petición a:", config.method?.toUpperCase(), config.url);
    
    const token = localStorage.getItem("token");
    if (!config.headers) config.headers = {};
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log("✅ Enviando token:", token.substring(0, 20) + "...");
      console.log("📨 Headers:", config.headers);
    } else {
      console.warn("⚠️ No se encontró token en localStorage");
    }
    return config;
  },
  (error) => {
    console.error("❌ Error en la petición:", error);
    return Promise.reject(error);
  }
);

// Interceptor para respuestas
api.interceptors.response.use(
  (response) => {
    console.log("✅ Respuesta exitosa:", response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error("❌ Error en respuesta:", {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message,
      data: error.response?.data
    });
    return Promise.reject(error);
  }
);export default api;